export default __webpack_public_path__ + "static/media/tick-mark.2c8e1540.png";